import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import router from './router/index'
import store from './vuex/store'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter'
import _ from 'lodash';
import routerInit from './router/router-actions'
// import axiosInterceptors from './init/axios-interceptors';
// import initEditorQuill from './init/editor-quill'
// import has from './directives/has'
// import focus from './directives/focus'

import vueModuleLoader from 'vue-module-loader'
// import localModule from './module'

// css
// import 'element-ui/lib/theme-chalk/index.css'
// import 'swiper/swiper.scss'
import 'vue-resize/dist/vue-resize.css'
// import 'cropperjs/dist/cropper.css';
import "./scss/index.scss"

// Add additional themes.
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

import VueResize from 'vue-resize'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'

// import 'jzl-web-components/lib/jwcomps/jwcomps.css';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTippy, { TippyComponent } from "vue-tippy";
import VModal from 'vue-js-modal';
import VueGridLayout from 'vue-grid-layout';
import JzlWebApi from "jzl-web-api"
import JzlWebComponents from "jzl-web-components"
import QrcodeVue        from 'qrcode.vue'

// components
Vue.component('v-chart',                    ECharts);
Vue.component('GridLayout',                 VueGridLayout.GridLayout);
Vue.component('GridItem',                   VueGridLayout.GridItem);
Vue.component("PerfectScrollbar",           VuePerfectScrollbar);
// Vue.component('dync-comp',                  dyncComp);
Vue.component("tippy",                      TippyComponent);
Vue.component("QrcodeVue",                  QrcodeVue);

Vue.use(VueRouter);
Vue.use(ElementUI);
// Vue.use(VueResource)
Vue.use(VueResize)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VModal, { dynamicDefaults: { draggable: true, resizable: true } });
Vue.use(VueTippy);
Vue.use(JzlWebApi);
Vue.use(JzlWebComponents);

const cache = setupCache({
    debug: true,
    maxAge: 500,
    exclude: {
        query: false,
        // methods: ['post', 'patch', 'put', 'delete']
    }
})

const $axiosNoCache = axios.create();

axios.defaults.adapter= cache.adapter;

const axiosList = [ axios, $axiosNoCache ];
// 注册特有的axios全局拦截器
if(process.env.NODE_ENV === 'production') {
    JzlWebComponents.AxiosInterceptor(axiosList, store, null, null, "pc");
} else {
    JzlWebComponents.AxiosInterceptor(axiosList, store, function (pid) {
        if(!pid) {
            if(Vue.prototype.$utils) {
                pid = Vue.prototype.$utils.getProjectId();
            }
        }

        Vue.prototype.$dialog.alert({
            title: '登录提示',
            message: '您未登录或登录已失效，请重新登录！',
        }).then(() => {

            let isMiniprogram = Vue.prototype.$utils.isEnvMiniprogram();
            let url = window.location.href;

            if(isMiniprogram) {
                wx.miniProgram.navigateTo({url: `/pages/login/login?url=${encodeURIComponent(url)}`})
            } else {
                router.replace({
                    name: 'login',
                    query: {
                        pid: pid
                    },
                    replace: true
                });
            }
        });
    }, function (error, pid) {
        let msg = _.get(error, 'response.data') || _.get(error, 'message') || '接口调用错误，请稍后再试！';
        Vue.prototype.$toast.fail(msg);
    }, "pc");
}

// 图标库单独特殊处理
JzlWebComponents.IconLib(store);

// Directive
// Vue.directive('has', has)
// Vue.directive('focus', focus)

// Filters

// router
routerInit(router);
// axios
// axiosInterceptors(router);

window.axios = axios;
window.$axiosNoCache = $axiosNoCache;
window._ = _;

import App from './App'

Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.prototype.$axios = axios;
Vue.prototype.$axiosNoCache = $axiosNoCache;

Vue.use(vueModuleLoader, { store })

const app = new Vue({
    store,
    router,
    ...App
});

// app.$moduleLoader(localModule)
app.$mount('#app')
